import React from 'react'

import Loading from '../../../components/layout/Loading'
import SelectInput from '../../../components/form/SelectInput'
import { useI18N } from '../../../../libraries/i18n/hook'
import { useAllDocumentTypes } from '../../../../hocs/content/useDocuments'

type Props = {
  onChange: (values: { docTypes: string[] }) => void,
  values?: string[]
}
const TypeSelectBox: React.FC<Props> = ({ values, onChange }) => {
  const { t } = useI18N()
  const { data, isLoading } = useAllDocumentTypes()

  const handleChange = (ids: string[]) => {
    onChange({ docTypes: ids })
  }

  if(isLoading) return <Loading />
  const options = data?.map(({ name, id }) => ({ label: name, value: id.toString() }))
  if(!options) return null
  return (
    <SelectInput
      isDisabled={options?.length === 0}
      value={options?.filter(cat => values?.includes(cat.value))}
      name='docTypes'
      label={t('content.documentTypes')}
      onChange={handleChange}
      options={options}
      autoMinWidth
    />
  )
}

export default TypeSelectBox
